module.exports = "<canvas #canvas style=\"width: 100%\"></canvas>\n"